import { Navigate, useLocation } from "react-router-dom";
import SessionCheckout from "./SessionCheckout";

// /checkout?booking=<id> pays for a held roadmap-session slot; there is
// nothing to pay for without a booking, so plain /checkout goes home.
function Checkout() {
  const bookingId = new URLSearchParams(useLocation().search).get("booking");
  return bookingId ? <SessionCheckout bookingId={bookingId} /> : <Navigate to="/" replace />;
}

export default Checkout;
